var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"css":false,"mode":"out-in"},on:{"enter":_vm.pageEnter,"leave":_vm.pageLeave}},[_c('keep-alive',{attrs:{"include":"magazineList"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }